import { Component, OnInit, AfterViewInit, ChangeDetectorRef, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormBuilder, FormGroup } from '@angular/forms';

import { catchError, finalize, Observable, Subject, throwError } from 'rxjs';
import { AuthenticationService } from '../../../core/services/auth.service';
import { Credentials } from '../../../entities/Credentials';
import { User } from '../../../entities/User';
import { ActivatedRoute, Router } from '@angular/router';
// import { ToastrService } from 'ngx-toastr';

import { environment } from '../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { fadeInUpAnimation } from 'src/app/shared/ui/fade-in-up.animation';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [fadeInUpAnimation]
})

/**
 * Login component
 */
export class LoginComponent implements OnInit {

  loginForm: UntypedFormGroup;
  public credentials: Credentials;
  public textLogin: string = 'Iniciar Sesión';
  public idUsuario;
  submitted = false;
  error = '';
  returnUrl: string;
  public loading: boolean = false
  public passwordType: string = "password"
  public showModalContrasena: boolean;


  // set the currenr year
  year: number = new Date().getFullYear();

  // tslint:disable-next-line: max-line-length
  constructor(private router: Router,
    private auth: AuthenticationService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private modalService: NgbModal) { }

  ngOnInit() {
    this.initForm();
    document.body.setAttribute('class', 'authentication-bg');

    
    // reset login status
    // this.authenticationService.logout();
    // get return url from route parameters or default to '/'
    // tslint:disable-next-line: no-string-literal
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  cambiarContraseñas(){
    this.router.navigateByUrl('/account/reset-password')
  }

  type = 'password'
  myFunctionPasswordCurrent() {
    if (this.type === "password") {
      this.type = "text";
    } else {
      this.type = "password";
    }
  }

  initForm() {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      // email: ['admin@themesbrand.com', [Validators.required, Validators.email]],
      // password: ['123456', [Validators.required]],
    });
  }

  ngOnDestroy() {
    document.body.classList.remove('authentication-bg')
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  /**
   * Form submit
   */
  // onSubmit() {
  //   this.submitted = true;

  //   // stop here if form is invalid
  //   if (this.loginForm.invalid) {
  //     return;
  //   } else {
  //     if (environment.defaultauth === 'firebase') {
  //       this.auth.login(this.f.email.value, this.f.password.value).then((res: any) => {
  //         document.body.removeAttribute('class');
  //         this.router.navigate(['/']);
  //       })
  //         .catch(error => {
  //           this.error = error ? error : '';
  //         });
  //     } else {
  //       // this.authFackservice.login(this.f.email.value, this.f.password.value)
  //       //   .pipe(first())
  //       //   .subscribe(
  //       //     data => {
  //       //       this.router.navigate(['/']);
  //       //     },
  //       //     error => {
  //       //       this.error = error ? error : '';
  //       //     });
  //     }
  //   }
  // }

  @ViewChild('StaticDataModal') StaticDataModal: TemplateRef<any>;
  @ViewChild('largeDataModal') largeDataModal: TemplateRef<any>;

  maskEmail(email: string): string {
    if (!email) return '';
    const [name, domain] = email.split('@');
    if (!name || !domain) return email;

    if (name.length <= 2) {
      return name[0] + '*@' + domain;
    }
    const masked = name[0] + '*'.repeat(name.length - 2) + name[name.length - 1];
    return `${masked}@${domain}`;
  }
  
  get correoUsuarioMasked(): string {
    return this.maskEmail(this.correoUsuario);
  }

  public correoUsuario: string = '';
  onSubmit() {
    this.loading = true;
    this.textLogin = 'Cargando...';
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    // this.loading = true;
    this.credentials = this.loginForm.value;

    this.auth.authenticate(this.credentials).pipe(
      catchError((error) => {
        this.loading = false;
        this.textLogin = 'Iniciar Sesión';
        const status = error?.status;
        const message = status && status !== 400 && status !== 401
          ? 'No se pudo iniciar sesión'
          : 'Usuario y/o contraseña incorrectos';
        this.toastr.error(message);
        return throwError(() => error);
      })
    ).subscribe((result: User) => {

      this.correoUsuario = result.user.userName;
      if (result.user.validPassword === false) {
        setTimeout(() => {
          this.showModalContrasena = true;
          this.modalService.open(this.StaticDataModal, { backdrop: 'static', centered: true });
        }, 400);
      } else {
        this.showModalContrasena = false;
        this.modalService.dismissAll();
      }

      this.auth.setData(result);
      const { rol, nombre, apellidoPaterno } = result.user;
      const tienePermisoDashboard = result.permisos.some(p => p.idPermiso == "2");

      let redirectUrl = '/contacts/profile';

      if (rol.nombre === 'Técnico') {
        redirectUrl = '/desarrolladores/bienvenida';
      } else if (tienePermisoDashboard) {
        redirectUrl = '/default';
      }
      this.router.navigate([redirectUrl]);



      const nombreUsuario = result.user.nombre;
      const apellidoUsuario = result.user.apellidoPaterno;

      this.toastr.success(`¡Hola ${nombreUsuario} ${apellidoUsuario}!`, 'Bienvenido');

      this.loading = false;
      this.textLogin = 'Iniciar Sesión';
    });
    // this.auth.authenticate(this.credentials).subscribe(
    //   (result: User) => {
    //     this.auth.setData(result);
    //     this.router.navigate(['']);
    //   },
    //   err=>{
    //     console.log(err);
    //     // this.toastr.error('Usuario o contraseña incorrectos')
    //   })
  }

  // onSubmit(){
  //   const data = {
  //     "id": '7',
  //     "nombre": "luis enrique",
  //     "email": "luisnm1@gmail.com",
  //     "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3MTAxOTY5MjEsImV4cCI6MTcxMDIwMDUyMX0.73QOGXDkxbXS7oSjWxSMyt-LKg0xalqC_o3jVGGQD2U",
  //     "permisos": [
  //         {
  //             "IdPermiso": 3
  //         },
  //         {
  //             "IdPermiso": 4
  //         },
  //         {
  //             "IdPermiso": 5
  //         },
  //         {
  //             "IdPermiso": 8
  //         },
  //         {
  //             "IdPermiso": 6
  //         },
  //         {
  //             "IdPermiso": 7
  //         }
  //     ]
  // };
  //   this.auth.setData(data);
  //   this.router.navigate(['']);
  // }


  public loadingTwo: boolean = false;
  public submitTwo: string = 'Guardar';
  formPasswordLoader = false;
  minCaracteres = false;
  maxCaracteres = false;
  hasNumber = false;
  hasMinus = false;
  hasMayus = false;
  espCaracter = false;
  passwordComparison = () => this.formPassword.PasswordNuevo
  formPassword: any = {
    password: '',
    newPassword: '',
    confirmPassword: ''
  }
  /**
  * Static modal
  * @param StaticDataModal modal content
  */
  StaticModal(StaticDataModal: any) {
    this.modalService.open(StaticDataModal, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }

  MaryModal(modal?: any, content?: any) {
    if (modal && typeof modal.close === 'function') {
      modal.close();
    }
    setTimeout(() => {
      if (content) {
        this.modalService.open(content, { backdrop: 'static', centered: true });
      } else if (this.largeDataModal) {
        this.modalService.open(this.largeDataModal, { backdrop: 'static' });
      }
    }, 400);
  }

  passwordsMatch: boolean = false;
  checkPasswordsMatch() {
    const { newPassword, confirmPassword } = this.formPassword;
    this.passwordsMatch = newPassword && confirmPassword && newPassword != confirmPassword;
  }

  onFormSubmitPassword(e: any, modal: any) {
    e.preventDefault();
    this.loadingTwo = true;
    this.submitTwo = 'Guardando...';

    if (this.formPassword.newPassword !== this.formPassword.confirmPassword) {
      this.toastr.error('Las contraseñas no coinciden.', 'Error de Validación');
      this.loadingTwo = false;
      this.submitTwo = 'Guardar';
      return;
    }

    const passwordPayload = {
      password: this.formPassword.password,
      newPassword: this.formPassword.newPassword,
      confirmPassword: this.formPassword.confirmPassword,
      validPassword: true
    };

    this.authService.changePasswordPerfil(passwordPayload).subscribe(
      (response: string) => {
        this.loadingTwo = false;
        this.submitTwo = 'Guardar';
        if (response) {
          Swal.fire({
            title: '¡Operación Exitosa!',
            text: 'Se ha modificado correctamente su contraseña.',
            icon: 'success',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Confirmar',
          }).then(() => {
            modal.close('Close click');
            this.resetForm();
          });
        } else {
          this.toastr.error('Formato de respuesta inesperado.', 'Error');
        }
      },
      (error: string) => {
        this.loadingTwo = false;
        this.submitTwo = 'Guardar';
        Swal.fire({
          title: '¡Ops!',
          text: error,
          icon: 'error',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Confirmar',
        });
      }
    );
  }

  onPasswordInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.minCaracteres = value.length >= 6;
    this.maxCaracteres = value.length <= 16;
    this.hasNumber = /\d/.test(value);
    this.hasMinus = /[a-z]/.test(value);
    this.hasMayus = /[A-Z]/.test(value);
    this.espCaracter = /[^\w\d]/.test(value);
  }

  private resetForm() {
    this.formPassword = {
      password: '',
      newPassword: '',
      confirmPassword: ''
    };
    this.formPasswordLoader = false;
    this.passwordsMatch = false;
  }

  /**
   * Open Large modal
   * @param largeDataModal large modal data
   */
  largeModal(largeDataModal: any) {
    this.modalService.open(largeDataModal, {
      size: 'lg', windowClass: 'modal-holder', centered: true, backdrop: 'static',
      keyboard: false,
    });
  }

  type2 = 'password'
  type3 = 'password'
  myFunctionPasswordConfirm() {
    if (this.type2 === "password") {
      this.type2 = "text";
    } else {
      this.type2 = "password";
    }
  }

  myFunctionPasswordConfirmNew() {
    if (this.type3 === "password") {
      this.type3 = "text";
    } else {
      this.type3 = "password";
    }
  }
}